import React from 'react';
var ARROW_HEAD_SIZE = 30;
var ArrowHead = function (_a) {
    var name = _a.name, path = _a.path;
    return (React.createElement("marker", { refX: 0, refY: 0, viewBox: (-1.0 * ARROW_HEAD_SIZE) + ' ' + (-0.5 * ARROW_HEAD_SIZE) + ' ' + ARROW_HEAD_SIZE + ' ' + ARROW_HEAD_SIZE, orient: 'auto', fill: '#ffffff', stroke: '#CED3D9', strokeWidth: 1, markerWidth: ARROW_HEAD_SIZE, markerHeight: ARROW_HEAD_SIZE, id: name },
        React.createElement("path", { d: path })));
};
export default ArrowHead;
//# sourceMappingURL=ArrowHead.js.map